import { createSlice } from "@reduxjs/toolkit";
import { 
  getVoiceFlow, 
  createVoiceFlow, 
  updateVoiceFlow, 
  deleteVoiceFlow,
  clearLocalActiveVoiceFlow 
} from "./actions";

export const initialState = {
  voiceFlow: { 
    id: '', 
    phone: '', 
    email: '', 
    prompt: '', 
    updated_at: '' 
  },
  loading: false
};

const slice = createSlice({
  name: 'voiceFlows',
  initialState,
  extraReducers(builder) {
    builder
      .addCase(getVoiceFlow.pending, (state) => {
        state.loading = true;
      })
      .addCase(getVoiceFlow.fulfilled, (state, action) => {
        const {  voice_flow } = action.payload;
        const voiceFlow = { ...state.voiceFlow, ...voice_flow };
        
        state.loading = false;
        state.voiceFlow = voiceFlow;
      })
      .addCase(getVoiceFlow.rejected, (state) => {
        state.loading = false;
      })
      .addCase(createVoiceFlow.pending, (state) => {
        state.loading = true;
      })
      .addCase(createVoiceFlow.fulfilled, (state, action) => {
        const { voice_flow } = action.payload;
        
        state.loading = false;
        state.voiceFlow = voice_flow;       
      })
      .addCase(createVoiceFlow.rejected, (state) => {
        state.loading = false;
      })
      .addCase(updateVoiceFlow.pending, (state) => {
        state.loading = true;
      })
      .addCase(updateVoiceFlow.fulfilled, (state, action) => {
        const { status, voice_flow } = action.payload;
        const updatedVoiceFlow = { ...state.voiceFlow, ...voice_flow };
        
        state.loading = false;
        if (status === 204) state.voiceFlow = updatedVoiceFlow;       
      })
      .addCase(updateVoiceFlow.rejected, (state) => {
        state.loading = false;
      })
      .addCase(deleteVoiceFlow.pending, (state) => {
        state.loading = true;
      })
      .addCase(deleteVoiceFlow.fulfilled, (state, action) => {
        const { status } = action.payload;

        state.loading = false;
        if (status === 204) state.voiceFlow = initialState.voiceFlow;       
      })
      .addCase(deleteVoiceFlow.rejected, (state) => {
        state.loading = false;
      })
      .addCase(clearLocalActiveVoiceFlow, state => {
        state.voiceFlow = initialState.voiceFlow;
      })
  }
})

export default slice.reducer;